import * as React from "react";
import { Container, Image, Segment, Icon } from "semantic-ui-react";
import styled from "styled-components";
import abgLogo from "./images/logo_mission_statement.svg";
import "../PageHeaderBar/PageHeaderBar.css";

const Right = styled.div` 
  float: right; 
`;

const _Container = ({ className, children }: { [key: string]: any }) => (
    <Container className={className}>{children}</Container>
);
const __Container = styled(_Container)` 
  font-size: 11px !important; 
  color: rgb(34, 74, 116); 
  line-height: 30px; 
 
  @media only screen and (min-width: 1200px) { 
    width: 986px; 
    margin-left: auto !important; 
    margin-right: auto !important; 
  } 
`;

const _Segment = (props) => (
    <Segment basic align="right" className={props.className}>
        {props.children}
    </Segment>
);

const StyledSegment = styled(_Segment)`
    background-color: ${(props) => props.theme.header.bg} !important;
    padding: 0  !important;
    .top_bar_text_bold {
        font-family: "FigTree-Medium", sans-serif !important;
        height: 30px;
        line-height: 30px;
    }
`;

const StyledContainer = styled(Container)`
    .ui.image.logo {
        margin: 12px 0 !important;
        height: 48px;
        width: auto;
    }
    .right {
        float: right;
    }
    .left {
        float: left;
    }
    @media only screen and (min-width: 1200px) {
        width: 986px;
        margin-left: auto !important;
        margin-right: auto !important;
    }
`;

const StyledSegmentInner = styled(Segment)` 
  padding: 0 !important; 
  z-index: 100; 
`;

const logoNavigateUrl = (props) => {
    if (props.logoUrl) {
        window.location.href = props.logoUrl;
    }
};


const C = (props) => (
    <>
        <StyledSegment>
            <__Container>{props.children}</__Container>
        </StyledSegment>
        <StyledSegmentInner basic clearing>
            <StyledContainer>
                {/* <Image className="ui right image logo" src={props.logoRight} /> */}
                <div className="right">
                    <div className="masthead__contact_details">
                        <p className="contact_details__caption">
                            Speak directly to our team
                        </p>

                        <span className="contact_details__phone_number">{props.telNo}</span>
                    </div>
                </div>
                <Image className="ui left image logo" src={props.logoLeft || abgLogo} onClick={() => logoNavigateUrl(props) } />
            </StyledContainer>
        </StyledSegmentInner>
        <StyledSegmentInner basic clearing>
            <header className="sub_heading">
                <StyledContainer>
                    <span className="sub_heading__text">{props.title}</span>

                    <Image className="ui right image logo" src={props.logoRight} />
                </StyledContainer>
            </header>
        </StyledSegmentInner>
    </>
);

const C2 = styled(C)` 
  background-color: ${(props) => props.theme.header.bg} !important; 
  padding: 0 1rem !important; 
`;

interface IPageHeaderBarProps {
    authenticated?: boolean | false;
    userName?: string | null;
    telNo?: string;
    logoLeft?: any | null;
    logoRight?: any | null;
    logout(): void | null;
    logoUrl?: string | null;
}

export class PageHeaderBar extends React.Component<IPageHeaderBarProps> {
    renderLoggedInUserName = () => {
        if (this.props.authenticated) {
            return (
                <>
                    <Right className="top_bar_text_bold">
                        <span>{this.props.userName}</span>
                        &nbsp;&nbsp;
                        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                        <span> 
              <a
                  href="/#"
                  onClick={(e) => {
                      e.preventDefault();
                      if (this.props.logout) this.props.logout();
                  }}
              > 
                Logout 
              </a> 
            </span>
                    </Right>
                    <div className="right not-mobile"> 
            <span className="top_bar_text_bold"> 
              Need some help? Call on {this.props.telNo} 
            </span>
                        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                    </div>
                </>
            );
        } else {
            return (
                <span className="top_bar_text_bold"> 
          Need some helpsss? Call us on {this.props.telNo} 
        </span>
            );
        }

        return null;
    };

    render() {
        return <C2 {...this.props}></C2>;
    }
} 
